/**
 * @generated SignedSource<<69a0e7c62ded2e0527bf9e15c32e4627>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateResolvedAutoReplyInput = {
  resolvedEnabled: boolean;
  resolvedFromName: string;
  resolvedFromEmail: string;
  resolvedBodyHtml: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type useUpdateResolvedAutoReplyMutation$variables = {
  input: UpdateResolvedAutoReplyInput;
};
export type useUpdateResolvedAutoReplyMutation$data = {
  readonly updateResolvedAutoReply: {
    readonly clientMutationId: string | null;
    readonly autoReply: {
      readonly resolvedEnabled: boolean;
      readonly resolvedFromName: string;
      readonly resolvedFromEmail: string;
      readonly resolvedBodyHtml: string;
    } | null;
  } | null;
};
export type useUpdateResolvedAutoReplyMutation = {
  variables: useUpdateResolvedAutoReplyMutation$variables;
  response: useUpdateResolvedAutoReplyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateResolvedAutoReplyPayload",
    "kind": "LinkedField",
    "name": "updateResolvedAutoReply",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AutoReplyConfig",
        "kind": "LinkedField",
        "name": "autoReply",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resolvedEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resolvedFromName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resolvedFromEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resolvedBodyHtml",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateResolvedAutoReplyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateResolvedAutoReplyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e83c0cfe4f39a804b22a84ddc90f7348",
    "id": null,
    "metadata": {},
    "name": "useUpdateResolvedAutoReplyMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateResolvedAutoReplyMutation(\n  $input: UpdateResolvedAutoReplyInput!\n) {\n  updateResolvedAutoReply(input: $input) {\n    clientMutationId\n    autoReply {\n      resolvedEnabled\n      resolvedFromName\n      resolvedFromEmail\n      resolvedBodyHtml\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f3032ca8834100dc811bd2878c2a538";

export default node;
